var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "se-search" }, [
    _c(
      "form",
      {
        staticClass: "se-search__form",
        attrs: { action: "#" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.make_search_request()
          },
        },
      },
      [
        _c("div", { staticClass: "se-search__input-container" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.search,
                expression: "search",
              },
            ],
            staticClass: "se-search__input",
            attrs: { type: "text", required: "", placeholder: "Type" },
            domProps: { value: _vm.search },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.search = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "se-search__button", attrs: { type: "submit" } },
            [_vm._v("Search")]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _vm.show_results
      ? _c(
          "div",
          { staticClass: "se-search__results" },
          [
            _vm.loading
              ? _c("img", {
                  attrs: {
                    src: "/wp-content/themes/digitalimpact/dist/images/loading.gif",
                    alt: "",
                  },
                })
              : [
                  _c("h5", { staticClass: "se-search__results-header" }, [
                    _vm._v("Results..."),
                  ]),
                  _vm._v(" "),
                  _vm.results.length == 0
                    ? _c("p", [_vm._v("No results found")])
                    : _c(
                        "ul",
                        { staticClass: "se-search__results-list" },
                        _vm._l(_vm.results, function (result) {
                          return _c(
                            "li",
                            { staticClass: "se-search__results-item" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "se-search__results-link",
                                  attrs: { href: result.link },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(result.title) +
                                      "\n\t\t\t\t\t\t"
                                  ),
                                  _c("img", {
                                    staticClass: "se-search__results-icon",
                                    attrs: {
                                      src: "/wp-content/themes/digitalimpact/dist/images/right.svg",
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                ],
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/components/StEnochSearch.vue